document.addEventListener('click', function(e){
  var t = e.target.closest('[data-menu-toggle]');
  if(t){ var n = document.getElementById('MobileNav'); if(n) n.classList.toggle('open'); }
  var th = e.target.closest('[data-thumb]');
  if(th){
    var main = document.getElementById('PdpMain');
    if(main){ main.src = th.dataset.full; main.srcset = ''; }
    document.querySelectorAll('[data-thumb]').forEach(function(b){ b.classList.remove('active'); });
    th.classList.add('active');
  }
});
